// extracted by mini-css-extract-plugin
module.exports = {"location":"Location_pc_location__meYeg","address":"Location_pc_address__iofdN","distance":"Location_pc_distance__H2TRn","viewMap":"Location_pc_viewMap__TmD_2"};